import "@apps-assets/scss/style.css";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ErrorBoundaries } from '@root-errors/index';
import { Provider } from 'react-redux';
import { StoreOfApp } from '@root-store/index';
import { BrowserRouter as Router } from 'react-router-dom';
import *as awsAmplify from "@root-services/aws-amplify";
import ClassificationRouter from "@root-routes/index";

awsAmplify.amazonCredentiel(); // connection amazon


/** Vérification de l'existance de l'element #root-tunnel-watch dans le DOM */
if(document.getElementById('root')){

  ReactDOM.render(
    <ErrorBoundaries>
      <Provider store={StoreOfApp}>
        <Router>
           <ClassificationRouter/>
        </Router>
      </Provider>  
    </ErrorBoundaries>
    ,
    document.getElementById('root') as HTMLElement
  );

}





// WEBPACK FOOTER //
// ./src/index.tsx